// Shared popover-dismiss behavior: closes on outside click, Escape, and
// route change. Extracted from TeamDropdown; used by AccountMenu too.

import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

export function useDismissable<T extends HTMLElement>() {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<T>(null);
  const location = useLocation();

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e: MouseEvent) => {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  // Close on route change. Without this the popover lingers after a row
  // click navigates away.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  return { open, setOpen, containerRef };
}
